import { useCallback, useEffect, useState } from 'react';

import { buildImageUrl } from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';
import { fetchMauiPersonalReadToken } from '@atlassian/conversation-assistant-service/common/utils/maui-media-token';

const isStaging = (): boolean => {
	return window.location.hostname.includes('jira-dev.com');
};

export const useImageUrl = (
	fileId: string | undefined,
	clientId: string | undefined,
	product: 'confluence' | 'jira' = 'confluence',
): string | null => {
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	const buildUrl = useCallback(async () => {
		if (!fileId || !clientId) {
			return;
		}

		const { token, collection } = await fetchMauiPersonalReadToken(product, clientId);
		const url = buildImageUrl({
			fileId,
			token: token.split('Bearer ')[1],
			collection,
			clientId,
			isStaging: isStaging(),
		});
		setImageUrl(url);
	}, [fileId, clientId, product]);

	useEffect(() => {
		if (!fileId || !clientId) {
			setImageUrl(null);
			return;
		}

		buildUrl();
	}, [buildUrl, fileId, clientId]);

	return imageUrl;
};
